import { Link as _Link, LinkProps } from 'react-router-dom';

export const Link = _Link as React.ComponentType<LinkProps>;
